module.exports = `

.react-jinke-music-player-main svg:active, .react-jinke-music-player-main svg:hover {
    color: #b8bb26
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle, .react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-track {
    background-color: #b8bb26;
    border-color: #79740e
}

.react-jinke-music-player-main ::-webkit-scrollbar-thumb {
    background-color: #b8bb26;
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle:active {
    box-shadow: 0 0 2px #b8bb26
}

.react-jinke-music-player-main .audio-item.playing svg {
    color: #b8bb26
}

.react-jinke-music-player-main .audio-item.playing .player-singer {
    color: #b8bb26 !important
}

.react-jinke-music-player-main .rc-slider-rail {
    background-color: #e6e9c1 !important
}

.react-jinke-music-player-main .lyric-btn {
    color: #ebdbb2 !important
}

.react-jinke-music-player-main .music-player-panel {
    color: #ebdbb2 !important
}

.react-jinke-music-player-main .lyric-btn-active svg {
    color: #b8bb26 !important
}

.music-player-lyric {
    color: #b8bb26 !important
}

.audio-lists-panel-content .audio-item.playing, .audio-lists-panel-content .audio-item.playing svg {
    color: #b8bb26
}
.audio-lists-panel-content .audio-item:active .group:not([class=".player-delete"]) svg, .audio-lists-panel-content .audio-item:hover .group:not([class=".player-delete"]) svg {
    color: #b8bb26
}

.progress-bar-content .audio-title a {
    color: #ebdbb2
}

.MuiCheckbox-colorSecondary.Mui-checked {
    color: #b8bb26 !important
}

`
